import React from 'react';
import { Box, Grid, Typography } from '@mui/material';

/**
 * A single warm, rounded section card. Every step is just a stack of these
 * — replaces the old accordion-per-section pattern, which added a click
 * just to see fields that were already meant to be visible on that step.
 */
export default function FieldGroup({ title, children }) {
  return (
    <Box
      sx={{
        backgroundColor: '#fafaf8',
        border: '1px solid #ece7e0',
        borderRadius: '12px',
        padding: '18px 20px',
      }}
    >
      <Typography variant="subtitle1" sx={{ fontWeight: 600, mb: 2, color: '#3d3a34' }}>
        {title}
      </Typography>
      <Grid container spacing={2}>
        {children}
      </Grid>
    </Box>
  );
}